if (!window.__imageGalleryNavDelegated) {

	window.__imageGalleryNavDelegated = true;

	const step = (gallery, delta) => {
		const items = Array.from(gallery.querySelectorAll('[data-image-gallery-item]'));
		if (items.length < 2) return;

		const current = Math.max(0, items.findIndex(item => item.classList.contains('card__image-gallery-item--active')));
		const next = (current + delta + items.length) % items.length;

		items[current].classList.remove('card__image-gallery-item--active');
		items[next].classList.add('card__image-gallery-item--active');
	};

	document.addEventListener('click', e => {
		const button = e.target.closest && e.target.closest('[data-image-gallery-prev], [data-image-gallery-next]');
		if (!button) return;

		const card = button.closest('.card');
		const gallery = card && card.querySelector('[data-image-gallery]');
		if (!gallery) return;

		e.preventDefault();
		step(gallery, button.hasAttribute('data-image-gallery-prev') ? -1 : 1);
	});

}
